export const UNSUBSCRIBE_QUERY_PARAM = "unsubscribe";
export const UNSUBSCRIBE_QUERY_VALUE = "1";

export const UNSUBSCRIBE_SUCCESS_MESSAGE =
  "Solicitud de baja registrada. Debe ser aprobada y puede tardar unos días en tramitarse.";

export const UNSUBSCRIBE_LOGIN_NOTICE =
  "Para tramitar la baja debes iniciar sesión.";

function toSearchParams(input: string): URLSearchParams {
  if (!input) return new URLSearchParams();

  if (input.includes("?")) {
    return new URLSearchParams(input.slice(input.indexOf("?")));
  }

  return new URLSearchParams(input.startsWith("?") ? input : `?${input}`);
}

export function hasUnsubscribeIntent(searchOrPath: string): boolean {
  return toSearchParams(searchOrPath).get(UNSUBSCRIBE_QUERY_PARAM) === UNSUBSCRIBE_QUERY_VALUE;
}
